<template>
    <b-card no-body class="overflow-hidden" :style="{ height: height }">
        <b-skeleton-img :width="width" :height="height"/>
    </b-card>
</template>

<script>
export default {
    name: 'CardLoader',
    props: {
        width: {
            type: [String, Number],
            default: '100%',
        },
        height: {
            type: [String, Number],
            default: '100%',
        },
    },
}
</script>
